const checkIfHasAudio = (video) =>
    video.mozHasAudio ||
    Boolean(video.webkitAudioDecodedByteCount) ||
    Boolean(video.audioTracks && video.audioTracks.length)

export default checkIfHasAudio
